import React from 'react';
import { styled } from '@mui/material/styles';
import {Box, Grid} from '@material-ui/core';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Highcharts, { Point } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
//import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import '../styles/bizofficer-a.css';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

// const chartAbc = {          
// 	series: [70],
// 	options: {
// 	  colors:['#279411'],	
// 	  chart: {
// 		height: 350,
// 		type: 'radialBar',
// 	  },
// 	  plotOptions: {
// 		radialBar: {
// 		  hollow: {
// 			size: '70%',
// 		  }
// 		},
// 	  },
// 	  labels: ['Correct Answer: 7/30'],
// 	},
//   };


  export default function Execute() {
	const classes = useStyles();
	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	const [myData, setMyData] = React.useState([]); 
	const [pageLoading, setPageLoading] = React.useState(true); 

	const [progressBar, setProgressBar] = React.useState(0);
	const [progressBarFlag, setProgressBarFlag] = React.useState(0);
	const [progressBarColor, setProgressBarColor] = React.useState('red');
	const [progressBarRemarks, setProgressBarRemarks] = React.useState('');

	const [chartOneData, setChartOneData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: 'Overall Result'},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});
	const [chartTwoData, setChartTwoData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: 'Result With Help'},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});
	const [chartThreeData, setChartThreeData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: 'Result Without Help'},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});

	// const [chartTwoData, setChartTwoData] = React.useState({credits: false,chart: {type: 'column',height: 325},title: {text: ''},caption: {text: ''},tooltip: {valueSuffix: ''},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + '' : this.y + ''}}}},series: [{showInLegend: false,name: '',title:null,data: []}]});
	// const [chartThreeData, setChartThreeData] = React.useState({credits: false,chart: {type: 'column',height: 325},title: {text: ''},caption: {text: ''},tooltip: {formatter: function () { var time = this.y; var hours=Math.floor(time/3600); if(hours<10){hours='0'+hours;} var mins=Math.floor(time % 3600 / 60); if(mins<10){mins='0'+mins;} var secs=Math.floor(time % 3600 % 60); if(secs<10){secs='0'+secs;} return this.x+" "+hours+':'+mins+':'+secs; }},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function () { var time = this.y; var hours=Math.floor(time/3600); if(hours<10){hours='0'+hours;} var mins=Math.floor(time % 3600 / 60); if(mins<10){mins='0'+mins;} var secs=Math.floor(time % 3600 % 60); if(secs<10){secs='0'+secs;} return hours+':'+mins+':'+secs; }}}},series: [{showInLegend: false,name: '',title:null, data: []}]});
	// const [chartFourData, setChartFourData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: 'Time'},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});
	// const [chartFiveData, setChartFiveData] = React.useState({credits: false,chart: {type: 'column',height: 325},title: {text: 'Average Time'},caption: {text: ''},tooltip: {formatter: function () { var time = this.y; var hours=Math.floor(time/3600); if(hours<10){hours='0'+hours;} var mins=Math.floor(time % 3600 / 60); if(mins<10){mins='0'+mins;} var secs=Math.floor(time % 3600 % 60); if(secs<10){secs='0'+secs;} return this.x+" "+hours+':'+mins+':'+secs; }},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function () { var time = this.y; var hours=Math.floor(time/3600); if(hours<10){hours='0'+hours;} var mins=Math.floor(time % 3600 / 60); if(mins<10){mins='0'+mins;} var secs=Math.floor(time % 3600 % 60); if(secs<10){secs='0'+secs;} return hours+':'+mins+':'+secs; }}}},series: [{showInLegend: false,name: '',title:null, data: []}]});
	// const [chartSixData, setChartSixData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: 'Correctly attempted questions wise'},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});
	// const [chartSevenData, setChartSevenData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: 'Marks wise'},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});
	// const [chartEightData, setChartEightData] = React.useState({credits: false,chart:{type: 'pie',height: 300},title:{text: ''},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});


	const authResult = new URLSearchParams(window.location.search); 
	const testId = authResult.get('testId');
	const [value, setValue] = React.useState('1');

	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}
	
	const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
		height: 10,
		borderRadius: 5,
		[`&.${linearProgressClasses.colorPrimary}`]: {
		  backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
		},
		[`& .${linearProgressClasses.bar}`]: {
		  borderRadius: 5,
		  backgroundColor: theme.palette.mode === 'light' ? progressBarColor : '#308fe8',
		},
	  }));  
	  
	const handleChange = (event, newValue) => { //taboneboxid
		if(newValue==1){
		  document.getElementById('taboneboxid').style.display="";
		  document.getElementById('tabtwoboxid').style.display="none";
		  document.getElementById('tabthreeboxid').style.display="none";
		}else if(newValue==2){
		  document.getElementById('taboneboxid').style.display="none";
		  document.getElementById('tabtwoboxid').style.display="";
		  document.getElementById('tabthreeboxid').style.display="none";
		}else if(newValue==3){
		  document.getElementById('taboneboxid').style.display="none";
		  document.getElementById('tabtwoboxid').style.display="none";
		  document.getElementById('tabthreeboxid').style.display="";
		}else if(newValue==4){
		  window.location.href="testview?testId=ls"+testId;
		}	
		setValue(newValue);
	  };
  

	React.useEffect(() => {		
		getApiData();
	}, []); 

	async function getApiData(){
		///alert("asdfasdf");
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};
		axios.get(API_URL+'/learning-analytics?testSession='+testId, axiosHeader) 
		   .then(response => {
				setPageLoading(false);
			if(response && response.status===200 && response.data.responseTxt==='success'){
				///document.writeln(JSON.stringify(response.data.obj));
				setMyData(response.data.obj);
				
				if(response.data.obj.overallResultList && response.data.obj.overallResultList.length>0){
					setChartOneData({ series: [{ data: response.data.obj.overallResultList }] });
				}
				if(response.data.obj.resultWithHelpList && response.data.obj.resultWithHelpList.length>0){
					setChartTwoData({ series: [{ data: response.data.obj.resultWithHelpList }] });
				}
				///alert(JSON.stringify(response.data.obj.resultWithoutHelpList));
				if(response.data.obj.resultWithoutHelpList && response.data.obj.resultWithoutHelpList.length>0){
					setChartThreeData({ series: [{ data: response.data.obj.resultWithoutHelpList }] });
				}

				if(response.data.obj.progressBarObj && response.data.obj.progressBarObj.percentage){
					setProgressBar(response.data.obj.progressBarObj.percentage);	
					setProgressBarFlag(1);		
					setProgressBarColor(response.data.obj.progressBarObj.barColor);
					setProgressBarRemarks('');
					if(response.data.obj.progressBarObj.barColor==='green'){
						setProgressBarRemarks('Well done. Move to competitive mode');
					}else if(response.data.obj.progressBarObj.barColor==='orange'){
						setProgressBarRemarks('Good progress but still continue learning');
					}else{
						setProgressBarRemarks('Not upto mark. Continue learning');
					}
				}
				// setChartTwoData({ xAxis: [{ categories: ["Total Marks","Marks Obtained"] }] });
				// setChartTwoData({ series: [{ data: [{"y":response.data[0].fullMarks,"color":"#46d39a"},{"y":response.data[0].marksObtain,"color":"#e55759"}] }] });
				// setChartThreeData({ xAxis: [{ categories: ["Total Time","Time Spent","Remaining Time"] }] });
				// setChartThreeData({ series: [{ data: [{"y":response.data[0].totalTimeSeconds,"color":"#46d39a"},{"y":response.data[0].timeSpent,"color":"#e55759"},{"y":response.data[0].timeRemaining,"color":"#4198d7"}] }] });

				// setChartFourData({ series: [{ data: [{"y":response.data[0].timeTakenPercent,"name":"Time Taken","color":"#46d39a"},{"y":response.data[0].timeRemainingPercent,"name":"Time Ramaining","color":"#e55759"}] }] });
				// setChartFiveData({ xAxis: [{ categories: ["Available Time","Time taken on attempted questions"] }] });
				// setChartFiveData({ series: [{ data: [{"y":response.data[0].totalTimeSeconds,"color":"#46d39a"},{"y":response.data[0].timeSpent,"color":"#e55759"}] }] });

				// setChartSixData({ series: [{ data: [{"y":response.data[0].questionWiseKnowledgeUnknown,"name":"Unknown","color":"#e55759"},{"y":response.data[0].questionWiseKnowledgeKnown,"name":"Known to you","color":"#46d39a"}] }] });
				// setChartSevenData({ series: [{ data: [{"y":response.data[0].marksWiseKnowledgeUnknown,"name":"Unknown","color":"#e55759"},{"y":response.data[0].marksWiseKnowledgeKnown,"name":"Known to you","color":"#46d39a"}] }] });
				// setChartEightData({ series: [{ data: [{"y":response.data[0].percentageCorrectAttemptedQuestions,"name":"Correct Questions","color":"#46d39a"},{"y":response.data[0].percentageIncorrectAttemptedQuestions,"name":"Incorrect Questions","color":"#e55759"}] }] });
			
			} else if (response && response.data && response.data.responseTxt === "invalidToken") {
				window.localStorage.removeItem("etlStudentObj");
				window.localStorage.clear();
				window.location.href = 'logout';			
			
			}
	   })

	}


	return (
		<div> 
				<MetaTags>
            		<title>Analytics</title>
          		</MetaTags>
				
				<Header />	
				<LeftDrawer />
				<main className={classes.content}>
				
				{pageLoading?<LinearProgress />:null}
				
				<Box style={{marginBottom:150, marginLeft:20, marginRight:20}}>	

				{myData?
					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={6} sm={12} xs={12}>
									<h3 className="heading" >{myData.testName}</h3>
									<h4 style={{color:'#f50057'}}>Date: {myData.submitDate}</h4>
								</Grid>
								<Grid item md={6} sm={12} xs={12}>
									<Grid container spacing={2}>
										<Grid item md={3} xs={3} className='correctmarksboxx' >
											{myData.totalQuestion}<br/>
											Total Questions
										</Grid>
										<Grid item md={3} xs={3} className='correctmarksboxx' >
											{myData.helpCounter}<br/>
											Help in Questions
										</Grid>
										<Grid item md={2} xs={2} className='correctmarksboxx' >
											{myData.correctQuestion}<br/>
											Correct
										</Grid>
										<Grid item md={2} xs={2} className='incorrectmarksbox' >
											{myData.incorrectQuestion}<br/>
											Incorrect
										</Grid>
										<Grid item md={2} xs={2} className='correctmarksboxy' >
											{myData.unattemptedQuestion}<br/>
											Unattempted
										</Grid>
									</Grid>
								</Grid>
							</Grid>
					</Box>
				:null}	

					<Box>
						<hr/>
					</Box>


					<Box mt={1} sx={{ width: '100%', typography: 'body1' }}>
						<TabContext value={value}>
							<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
							<TabList onChange={handleChange} centered variant="scrollable" scrollButtons="auto" aria-label="lab API tabs example">
								<Tab label="Performance" value="1" />
								<Tab label="View Answers" value="4" />
								{/* <Tab label="Time Management" value="2" />
								<Tab label="Inferences" value="3" /> */}
								
							</TabList>
							</Box>
							<TabPanel value="1"></TabPanel>
							<TabPanel value="2"></TabPanel>
							<TabPanel value="3"></TabPanel>
						</TabContext>
					</Box>

					{(progressBarFlag && progressBarFlag>0)?						
						<Box style={{marginTop:-50}} >
							<Grid container spacing={2}>
								<Grid item xs={12} style={{textAlign:'center'}} ><h3>Progress Bar</h3></Grid>
							</Grid>
							<Grid container spacing={2}>
								<Grid item md={4} sm={4} xs={12} ></Grid>
								<Grid item md={4} sm={4} xs={12} >
									<h1 style={{textAlign:'center', color:progressBarColor}}>{progressBar}%</h1>
									<BorderLinearProgress variant="determinate" value={progressBar} />
									{progressBarRemarks?<div style={{textAlign:'center'}}>{progressBarRemarks}</div>:null}
								</Grid>
								<Grid item md={4} sm={4} xs={12} ></Grid>
							</Grid>
						</Box>
					:null}			

					{/********************  Self Test ****************************/}
					{/********************  Overall Performance ****************************/}
					<Box id="taboneboxid" mt={1}>
						<Grid container spacing={2}>

							<Grid item   md={4} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartOneData}
								/>							
							</Grid>
							<Grid item   md={4} xs={12} >
								{<HighchartsReact
									highcharts={Highcharts}
									options={chartTwoData}
								/>}
							</Grid>
							<Grid item   md={4} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartThreeData}
								/>
							</Grid>

						</Grid>

					</Box>

					{(myData && myData.bloomPerformanceList && myData.bloomPerformanceList.length>0)?				
					<Box mt={5}>
						<Grid container spacing={2}>
							<Grid item md={2} sm={2} xs={12} ></Grid>
							<Grid item md={9} sm={8} xs={12} >
									<Grid container spacing={2}>
											<Grid item md={3} sm={2} xs={2} ><b>Bloom Name</b></Grid>
											<Grid item md={1} sm={2} xs={2} ><b>Total Questions</b></Grid>
											<Grid item md={1} sm={2} xs={2} ><b>Correct Questions</b></Grid>
											<Grid item md={1} sm={2} xs={2} ><b>Incorrect Questions</b></Grid>
											<Grid item md={1} sm={2} xs={2} ><b>Help Used Questions</b></Grid>
											<Grid item md={1} sm={2} xs={2} ><b>Correct Percentage</b></Grid>
									</Grid>
									<hr/>
									{myData.bloomPerformanceList.map((obj)=>(
									<Grid container spacing={2}>
											<Grid item md={3} sm={2} xs={2} ><b>{obj.bloomName}</b><hr/></Grid>
											<Grid item md={1} sm={2} xs={2} >{obj.totalQuestions}<hr/></Grid>
											<Grid item md={1} sm={2} xs={2} >{obj.correctQuestions}<hr/></Grid>
											<Grid item md={1} sm={2} xs={2} >{obj.incorrectQuestions}<hr/></Grid>
											<Grid item md={1} sm={2} xs={2} >{obj.helpUsedQuestions}<hr/></Grid>
											<Grid item md={1} sm={2} xs={2} >{obj.correctPercentage}%<hr/></Grid>
									</Grid>		
									))}
								
							</Grid>
							<Grid item md={1} sm={2} xs={12} ></Grid>
						</Grid>
					</Box>
					:null}

					{/********************  Time Management ****************************/}
					{/* <Box id="tabtwoboxid" style={{display:'none'}} mt={1}>
						<Grid container spacing={2}>												
							<Grid item   md={4} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartFourData}
								/>								
							</Grid>
							<Grid item   md={4} xs={12} >
								{<HighchartsReact
									highcharts={Highcharts}
									options={chartFiveData}
								/>}
							</Grid>
							<Grid item   md={4} xs={12} >
								<TableContainer component={Paper}>
									<Table aria-label="simple table">
										<TableBody>										
											<TableRow>
												<TableCell >Total time</TableCell>
												<TableCell >{myData.totalTimeLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Time taken</TableCell>
												<TableCell >{myData.spentTimeLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Time remaining</TableCell>
												<TableCell >{myData.remainingTimeLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Avg available time</TableCell>
												<TableCell >{myData.averageTimePerQuestionLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Avg. Speed per Question</TableCell>
												<TableCell >{myData.averageSpeedPerQuestionLabel}</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>

						</Grid>
					</Box> */}

					{/********************  Inferences ****************************/}
					{/* <Box id="tabthreeboxid" style={{display:'none'}} mt={1}>
						<Grid container spacing={2}>		
							<Grid item   md={12} xs={12} >
								<h2 style={{textAlign:'center',textTransform:'uppercase'}} >Overall Knowledge</h2>	
							</Grid>										
							<Grid item   md={4} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartSixData}
								/>	
							</Grid>
							<Grid item   md={4} xs={12} >
								{<HighchartsReact
									highcharts={Highcharts}
									options={chartSevenData}
								/>}
							</Grid>
							<Grid item   md={4} xs={12} >
								<TableContainer component={Paper}>
									<Table aria-label="simple table">
										<TableBody>										
											<TableRow>
												<TableCell >Total Questions</TableCell>
												<TableCell >{myData.totalQuestion}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Question Corrected</TableCell>
												<TableCell >{myData.correctAnswers}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Full Marks</TableCell>
												<TableCell >{myData.fullMarks}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Marks Obtained</TableCell>
												<TableCell >{myData.marksObtain}</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>

						</Grid>


						<Grid container spacing={2}>		
							<Grid item   md={12} xs={12} >
								<h2 style={{textAlign:'center',textTransform:'uppercase'}} >Accuracy of Attempted</h2>	
							</Grid>										
							<Grid item   md={6} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartEightData}
								/>	
							</Grid>
							<Grid item   md={6} xs={12} >
								<TableContainer component={Paper}>
									<Table aria-label="simple table">
										<TableBody>										
											<TableRow>
												<TableCell >Attempted Questions</TableCell>
												<TableCell >{myData.attemptedQuestions}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Correct Questions</TableCell>
												<TableCell >{myData.correctAnswers}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Incorrect Questions</TableCell>
												<TableCell >{myData.incorrectAnswers}</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>

						</Grid>


					</Box> */}

				</Box>
				</main>					
		</div>	
	);
  }